module.exports = __webpack_public_path__ + "static/media/cnh-open.ab91b9ea.svg";